<template>
  <div
    ref="checkboxContainer"
    class="checkbox-container"
    :class="{ 'disabled': disabled, 'checked': checked, 'indeterminate': indeterminate }"
    :tabindex="disabled || !focusable ? '' : 0"
    @keyup.enter="$emit('focus-update')"
  >
    <BaseIcon
      v-show="indeterminate"
      :color="disabled ? 'var(--pepper-400)' : 'var(--blueberry-1000)'"
      font-size="14px"
      icon="fa-dash"
    />
    <BaseIcon
      v-show="checked && !indeterminate"
      :color="disabled ? 'var(--pepper-400)' : 'white'"
      font-size="14px"
      icon="fa-check"
    />
  </div>
</template>

<script>
import BaseIcon from './BaseIcon.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faDash, faCheck } from '@fortawesome/pro-solid-svg-icons'

library.add(faDash, faCheck)
export default {
  name: 'CheckboxDecoration',
  components: {
    BaseIcon,
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    focusable: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['focus-update'],
}
</script>

<style scoped lang="scss">
.checkbox-container {
  border-radius: 3px;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  border: 1px solid var(--pepper-200);
  box-sizing: content-box;
  justify-content: center;
  display: flex;
  align-content: center;
  flex-wrap: wrap;

  &:not(.indeterminate):not(.disabled) {
    &:hover {
      border-color: var(--pepper-500);
    }
  }
  &:not(.indeterminate).checked {
    background-color: var(--blueberry-1000);
    border-color: var(--blueberry-1000);
    &:hover {
      background-color: var(--blueberry-800);
      border-color: var(--blueberry-800);
    }

    &.disabled {
      background-color: var(--pepper-100);
      border-color: var(--pepper-200);
      color: var(--pepper-400);
    }
  }

  &.disabled {
    background-color: var(--pepper-100);
    color: var(--pepper-400);
  }
}
.checkbox-container:focus {
  outline: none !important;
  border: 1px solid var(--blueberry-300);

  &.checked {
    border: 1px solid var(--blueberry-300);

  }
}
</style>
